import React, { useRef } from 'react'
import styled from 'styled-components'
import Pinger from './pinger'

const ClueNumberSpan = styled.span`
    position: absolute;
    top: -1px;
    left: 1px;
    font-size: 0.4em;

    @media only screen and (min-width: 1000px) {
        font-size: 0.4em !important;
    }
`

const Square = (props) => {
    const inputRef = useRef(null)
    const {
        text, filled, selected, mistake, user, highlighted, onClick, onKeyDown, style,
        pingKey, onPing, myColor, clueNumber,
    } = props

    return (
        <div
            onClick={onClick}
            className={[
                'Square',
                filled && 'filled',
                mistake && !filled && 'mistake',
                highlighted && `highlighted highlighted-${myColor}`,
                user && `user user-${user.color}`,
                selected && 'selected',
            ].join(' ')}
            style={style}>
            <div
                ref={inputRef}
                className='InputText'
                onChange={e => {
                    let { value: key } = e.target
                    if (key.length > 1) {
                        key = key[key.length - 1]
                    }
                    onKeyDown({ key, preventDefault: () => null })
                }}
                >
                    <ClueNumberSpan>{clueNumber}</ClueNumberSpan>
                    {text}
                </div>
            <Pinger pingKey={pingKey} onPing={onPing} />
        </div>
    )
}

export default Square
